var fetch = require('isomorphic-fetch');

var base_url=""

function format_url(url)
{
  if(url) {
    if(url.charAt(0) === '/') {
      return base_url + url;
    }
    else {
      return base_url + '/' + url;
    }
  }
}

module.exports = {
  get: function(url_) {
    var url = format_url(url_);
    return fetch(url).then((res) => res.json())
  },
  post_form: function(url_, data, next) {
    var url = format_url(url_);
    return fetch(url,
      { method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data) 
      })
    .then((res) => res.json())
  },
  set_base_url: function(url) {
    base_url = url;
  }

}


// WEBPACK FOOTER //
// ./lib/resource/index.js